export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-950 dark-section">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[640px] mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-4">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-10 md:mb-12">
            有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 text-center hover:bg-white/10 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-2xl bg-primary-500/20 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-400"></i>
              </div>
              <h3 className="font-heading font-bold text-white text-sm md:text-base mb-2">内容投稿</h3>
              <p className="text-[11px] md:text-xs text-foreground-500 leading-relaxed">
                推荐影片或提交片源<br />
                <span className="text-white/60">submit@dashixiongys.com</span>
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 text-center hover:bg-white/10 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-2xl bg-accent-500/20 flex items-center justify-center">
                <i className="ri-briefcase-line text-xl text-accent-400"></i>
              </div>
              <h3 className="font-heading font-bold text-white text-sm md:text-base mb-2">商务合作</h3>
              <p className="text-[11px] md:text-xs text-foreground-500 leading-relaxed">
                广告投放与品牌合作<br />
                <span className="text-white/60">biz@dashixiongys.com</span>
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 text-center hover:bg-white/10 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-2xl bg-secondary-500/20 flex items-center justify-center">
                <i className="ri-question-answer-line text-xl text-secondary-400"></i>
              </div>
              <h3 className="font-heading font-bold text-white text-sm md:text-base mb-2">问题反馈</h3>
              <p className="text-[11px] md:text-xs text-foreground-500 leading-relaxed">
                播放问题与功能建议<br />
                <span className="text-white/60">support@dashixiongys.com</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}